import { AppDispatch, AppThunk } from '../../definitions/types';
import getConfig from '../../config';

export function forwardToDolphinCms(
  urlParam: string = ''
): AppThunk {
  return (dispatch: AppDispatch) => {
    window.location.href = `${getConfig().dolphinCmsEndpoint}/wizard/${
      urlParam ? `?${urlParam}` : ''
    }`;
  };
}
